import React from 'react';
import styled from 'styled-components';
import { useControlValue } from '../../Contexts/ControlContext';
import { InputRadio } from '../../Common/InputRadio';
import { Description } from '../../Common/Description';

export const Templates = () => {
  const { data, changeTemplate } = useControlValue();
  const templateTypes = [
    {
      label: 'Golden State Company',
      name: 'template1',
    },
    {
      label: 'Moontide',
      name: 'template2',
    },
    {
      label: 'Emergent Media',
      name: 'template3',
    },
    {
      label: 'Ventura Blvd',
      name: 'template4',
    },
    {
      label: 'Southbay',
      name: 'template5',
    },
    {
      label: 'Launch CMD',
      name: 'template6',
    },
  ];

  return (
    <StyledForm>
      <Description>Pick your company</Description>
      {templateTypes.map((templateType) => (
        <InputRadio
          label={templateType.label}
          name={templateType.name}
          checked={data.template}
          onChange={changeTemplate}
          key={templateType.name}
        />
      ))}
    </StyledForm>
  );
};

const StyledForm = styled.form`
  animation: flipdown 0.2s ease both;
`;
